import { Component, OnInit } from '@angular/core';
import { AlarmService } from '../../services/alarm.service';
import { Observable } from 'rxjs';
import { TableComponent } from '../../../../../shared/src/lib/components/table/table.component';
import { TableHeaderComponent } from '../../../../../shared/src/lib/components/table-header/table-header.component';
import { AsyncPipe } from '@angular/common';
import { TableRowComponent } from '../../../../../shared/src/lib/components/table-row/table-row.component';
import { FormatAlarmMetadataPipe } from '../../pipes/format-alarm-metadata.pipe';

@Component({
    selector: 'app-alarm-metadata',
    templateUrl: './alarm-metadata.component.html',
    styleUrls: ['./alarm-metadata.component.scss'],
    imports: [TableComponent, TableHeaderComponent, TableRowComponent, AsyncPipe, FormatAlarmMetadataPipe]
})
export class AlarmMetadataComponent implements OnInit {

  public metadatas$: Observable<any[]>;

  constructor(private alarmService: AlarmService) {
  }

  ngOnInit(): void {
    this.metadatas$ = this.alarmService.alarmMetadatas$;
  }
}
